import { createFileRoute } from "@tanstack/react-router";
import { ExamplesHome } from "@/pages/3d/examples/ExamplesHome";

export const Route = createFileRoute("/demo/3d/examples/")({
  component: ExamplesHome,
});
